<template>
  <div class="col-md-3">
    <div class="card h-100 mb-0">
      <div class="card-body">
        <div class="col-md-12 h-100 d-flex flex-column justify-content-between">
          <FotoClienteRural
            :loading="loading"
            :foto-perfil="fotoPerfil"
            :modo-edicao-foto="modoEdicaoFoto"
            @updateFotoPerfil="handleUpdateFoto"
            @setLoading="$emit('update:loading', $event)"
          />
          <div>
            <div class="mb-2">
              <strong class="me-1">Cliente:</strong>
              <span>{{ nomeClienteCompleto }}</span>
            </div>
            <div class="mb-2">
              <strong class="me-1">Telefone:</strong>
              <span>{{ foneClienteRural }}</span>
            </div>
            <div class="mb-2">
              <router-link to="/astec/clienteRural">
                <b-button variant="secondary" class="mt-1 me-1">
                  <i class="mdi mdi-arrow-left-circle font-size-15"></i>
                  <span class="ms-1">Voltar</span>
                </b-button>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FotoClienteRural from "@/components/astec/FotoClienteRural.vue";

export default {
  name: "ClienteRuralSidebar",
  components: {
    FotoClienteRural,
  },
  data() {
    return {
      nomeClienteRural: "",
      telefoneClienteRural: "",
    };
  },

  props: {
    loading: Boolean,
    telefone: {
      type: String,
      default: "",
    },

    clienteRural: {
      type: String,
      default: "",
    },

    fotoPerfil: {
      type: Object,
      required: true,
      default: () => ({
        file: null,
        base64: null,
      }),
    },

    modoEdicaoFoto: {
      type: Boolean,
      default: false,
    },
  },

  mounted() {
    const storeCliente = this.$store.state.clienteRuralAstec;
    if (storeCliente) {
      this.nomeClienteRural = storeCliente.NMRAZAO;
      this.telefoneClienteRural = storeCliente.NRTELEFONE;
    }
  },

  computed: {
    nomeClienteCompleto() {
      return this.clienteRural || this.nomeClienteRural;
    },

    foneClienteRural() {
      const tel = this.telefone || this.telefoneClienteRural;
      if (!tel) return "";
      const numeroTelefone = tel.replace(/\D/g, "");
      if (numeroTelefone.length === 11) {
        return numeroTelefone.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
      } else if (numeroTelefone.length === 10) {
        return numeroTelefone.replace(/(\d{2})(\d{4})(\d{4})/, "($1) $2-$3");
      }
      return tel;
    },
  },

  methods: {
    handleUpdateFoto(novaFoto) {
      this.$emit("updateFotoPerfil", novaFoto);
    },
  },
};
</script>
